export default __webpack_public_path__ + "static/media/aspire-logo.99d4e704.jpg";